module.exports = __webpack_public_path__ + "static/media/search.5702bcad.svg";